import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import HeaderDashboard from "../components/HeaderDashboard";

function DashboardLayout() {
  const { token } = useAuth();

  if (!token) {
    return <Navigate to="/dashboard/login" />;
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#FFFFFF]">
      <HeaderDashboard />
      <Outlet />
    </div>
  )
};

export default DashboardLayout;
